// noinspection DuplicatedCode

import {Grid, Typography} from "@mui/material";
import React from "react";
import {Helmet} from "react-helmet";
import DualCounter from "./FamilyTreeComponents/dualCounter";
import BackContinueButtons from "./QuestionnaireComponents/BackContinueButtons";
import {useFormNavigation} from "../../Hooks/useFormNavigation";
import {useValidateToken} from "../../Hooks/useValidateToken";
import {useRelations} from "../../Hooks/useRelations";
import {useDispatch} from "react-redux";
import {addRelationsToDb, fetchRelations} from "../../Redux/relations/relationSlice";
import {filterRelationsIntoArray, filterRelationsWithNoData} from "./Helpers/filterRelations";
import {relationIDs} from "./Helpers/relationsMap";
import {useReduxDataHandler} from "../../Hooks/useFormDataHandler";
import useReduxFormData from "../../Hooks/useReduxFormData";

const TreeList_MothersRelations = () => {
  const {handleRadioChanged} = useReduxDataHandler();

  useValidateToken(true, "history");
  const [, , , , manifestationsState, addManifestations] = useReduxFormData();
  const {entities} = manifestationsState;

  const {handleFormNavigation} = useFormNavigation();
  const [selfRelativeState, setSelfRelativeState] = React.useState({});
  const dispatch = useDispatch();

  const {relationsIsLoading, relationsState} = useRelations();

  const {
    relationsUserId,
    motherPrId,
    momGrandmaId,
    momGrandpaId,
    momGrandmaMomId,
    momGrandmaDadId,
    momGrandpaMomId,
    momGrandpaDadId,
    relationsDbPosting,
    motherRelation,
  } = relationsState;

  const parentManis = [];

  React.useEffect(() => {
    if (motherRelation && Object.keys(motherRelation).length) {
      for (let i = 0; i < motherRelation.relationManis.length; i++) {
        parentManis.push(motherRelation.relationManis[i].manifestationId)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [motherRelation])

  return (
    relationsIsLoading
      ? undefined
      : <>
        <Helmet>
          <title>Your Mom's Family</title>
        </Helmet>
        <Grid container item xs={12} justifyContent={"center"} className="questionnaire-wrapper">
          <Grid item>
            <Typography textAlign={"center"} variant="h2" mt={5} mb={5}>
              Tell us about your <b className="text-emphasis">Mom's side of the family</b>.
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <form className="questionnaire-content family-tree"
                  onSubmit={async (e) => {
                    e.preventDefault();
                    const filtered = filterRelationsWithNoData(selfRelativeState, relationsUserId);
                    const arrToPost = filterRelationsIntoArray(filtered, relationsUserId);
                    await addManifestations(Object.values(entities).filter((m) => m.edited === true))
                      .unwrap()
                      .then(() => {
                        dispatch(addRelationsToDb(arrToPost))
                      })
                      .then(() => {
                        dispatch(fetchRelations())
                          .then(() => {
                            handleFormNavigation(e);
                          })
                      })
                  }}>
              <Grid spacing={2} container justifyContent={"center"} ml={"auto"} mr={"auto"}
                    className="questionnaire-inner-content">
                {!relationsIsLoading &&
                  <>
                    <Grid container item justifyContent={{sm: "center"}} flexDirection={"row"}>
                      <Grid item xs={6} md={4}>
                        <label htmlFor="unknownFHMom">
                          Do you know about your mom's family history?
                        </label>
                      </Grid>
                      <Grid item>
                        <input type="radio"
                               name={"unknownFHMom"}
                               value={4519}
                               opp-manifestation={163}
                               defaultChecked={parentManis.includes(4519) || parentManis.includes("4519")}
                               onChange={(e) => {
                                 handleRadioChanged(e, motherPrId)
                               }}
                        /><span>&nbsp;Yes&nbsp;</span>
                        <input type="radio"
                               name={"unknownFHMom"}
                               value={163}
                               opp-manifestation={4519}
                               defaultChecked={parentManis.includes(163) || parentManis.includes("163")}
                               onChange={(e) => {
                                 handleRadioChanged(e, motherPrId)
                               }}
                        /><span>&nbsp;No&nbsp;</span>
                      </Grid>
                    </Grid>
                    <div className={"family-tree-counters"}>
                      <div className={"family-tree-labels"}>
                        <label className="bold-text"
                               style={{marginBottom: "25px"}}>How many of the following do you have?</label>
                      </div>
                      <label>Mom's Family</label>
                      <br />
                      <DualCounter relationId={relationIDs.Uncle}
                                   side={"Maternal"}
                                   parentIds={{motherPrId: momGrandmaId, fatherPrId: momGrandpaId}}
                                   setRelatives={setSelfRelativeState} />
                      <DualCounter relationId={relationIDs.Aunt}
                                   side={"Maternal"}
                                   parentIds={{motherPrId: momGrandmaId, fatherPrId: momGrandpaId}}
                                   setRelatives={setSelfRelativeState} />
                      <label className="blue-label">Your maternal grandmother's family (Mom's Mom)</label>
                      <DualCounter relationId={relationIDs.Great_Uncle}
                                   side={"Maternal"}
                                   parentIds={{motherPrId: momGrandmaMomId, fatherPrId: momGrandmaDadId}}
                                   setRelatives={setSelfRelativeState} />
                      <DualCounter relationId={relationIDs.Great_Aunt}
                                   side={"Maternal"}
                                   parentIds={{motherPrId: momGrandmaMomId, fatherPrId: momGrandmaDadId}}
                                   setRelatives={setSelfRelativeState} />
                      <label className="blue-label">Your maternal grandfather's family (Mom's Dad)</label>
                      <DualCounter relationId={relationIDs.Great_Uncle}
                                   side={"Maternal"}
                                   parentIds={{motherPrId: momGrandpaMomId, fatherPrId: momGrandpaDadId}}
                                   setRelatives={setSelfRelativeState}
                                   parentKey={"a" + relationIDs.Great_Uncle}//for uniqueness on the page
                      />
                      <DualCounter relationId={relationIDs.Great_Aunt}
                                   side={"Maternal"}
                                   parentIds={{motherPrId: momGrandpaMomId, fatherPrId: momGrandpaDadId}}
                                   setRelatives={setSelfRelativeState}
                                   parentKey={"a" + relationIDs.Great_Aunt}//for uniqueness on the page
                      />
                    </div>
                  </>
                }
                <BackContinueButtons loading={relationsDbPosting} />
              </Grid>
            </form>
          </Grid>
        </Grid>
      </>
  );
}

export default TreeList_MothersRelations